import React from 'react';

import { FieldInput } from '@admin/styled/field_input';

export const FacilityTextInput: React.FC<React.InputHTMLAttributes<HTMLInputElement>> = (props) => (
  <FieldInput {...props} />
);
